import { Api } from 'vl-common/src/api';

export const getPatientList = (calling_guid, params) => {
  return () => Api.referrers.getPatientList(params).then(({ data }) => data);
};

export default getPatientList;
